import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicOMLDto extends EpimsBaseEntityDto {
  OilMineralLeaseName: string;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
